import React from 'react';
import './WhatWeDo.css';

function WhatWeDo() {
  return (
    <section className="what-we-do" id="what-we-do">
      <div className="container">
        <div className="whatwedo-content">
          <div className="whatwedo-text">
            <h1 className="whatwedo-title">Qué Hacemos</h1>
          </div>
        </div>
      </div>
    </section>
  );
}

export default WhatWeDo;
